<template>
  <div>
      <!-- <h2>Legal Structure Setup</h2> -->
        <v-btn   color="primary" class="ma-2 white--text"  @click="addLeagalStructuerDialog = true">
            {{ $t("legalStructure.add") }} <v-icon right dark> mdi-plus</v-icon>
        </v-btn>


       <!-- <b-button variant="outline-primary" v-b-modal.AddLegalStructure>
            <b-icon icon="plus-circle-fill"  scale="1" variant="success"></b-icon>
            Add Legal Structure
        </b-button> -->


        <!-- <b-table
        ref ="LegalStructureList"
        striped hover
        :items="items"
        :fields="fields"
        v-if="items.length > 0">
        <template #cell(Action)="row">
            <b-button size="sm" class="mr-2" @click="editLegalStructure(row.item,row.index)">Edit</b-button>
             <b-button  squared :variant="getVariant(row.item,1)" title="Activate" @click="updateSectorStatus(row.item,row.index,1)">
                <b-icon icon="person-check-fill" aria-hidden="true"></b-icon>
            </b-button>
            <b-button  squared :variant="getVariant(row.item,0)" title="DeActivate" @click="updateSectorStatus(row.item,row.index,0)">
                <b-icon icon="person-x-fill" aria-hidden="true"></b-icon>
            </b-button>
        </template>
        </b-table>
        <div v-if="items.length ==0">
            <center>
                <h2>No Items</h2>
            </center>
        </div>
         <b-modal id="AddLegalStructure" title="Add LegalStructure" hide-footer @show="onReset()" hide-backdrop>
            <b-form ref="form" @submit.stop.prevent="AddLegalStructure">
                <b-form-group
                label="English Name"
                label-for="englishName" >
                    <b-form-input
                        type="text"
                        id="txtEnglishName"
                        name="txtEnglishName"
                        placeholder="English Name"
                        v-model="$v.form.englishName.$model"
                        :state="validateState('englishName')"
                        aria-describedby="englishName-feedback"
                        >
                    </b-form-input>
                    <b-form-invalid-feedback id="englishName-feedback">
                        This is a required field and must be at least 3 characters.
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                label="Arabic Name"
                label-for="arabicName" >
                    <b-form-input
                        type="text"
                        id="txtArabicName"
                        name="txtArabicName"
                        placeholder="Arabic Name"
                        v-model="$v.form.arabicName.$model"
                        :state="validateState('arabicName')"
                        aria-describedby="arabicName-feedbackk"
                        >
                    </b-form-input>
                    <b-form-invalid-feedback id="arabicName-feedback">
                        This is a required field and must be at least 3 characters.
                    </b-form-invalid-feedback>
                </b-form-group>
            <b-button type="submit" variant="primary">Submit</b-button>
            <b-button class="ml-2" @click="onReset()">Reset</b-button>
            </b-form>
         </b-modal>
         <b-modal id="EditLegalStructure" title="Edit Legal Structure" hide-footer hide-backdrop>
            <b-form ref="form" @submit.stop.prevent="updateLegalStrcucture">
                 <b-form-group
                label="Id"
                label-for="Id" >
                   {{this.form.id}}
                </b-form-group>
                <b-form-group
                label="English Name"
                label-for="englishName" >
                    <b-form-input
                        type="text"
                        id="txtEnglishName"
                        name="txtEnglishName"
                        placeholder="English Name"
                        v-model="$v.form.englishName.$model"
                        :state="validateState('englishName')"
                        aria-describedby="englishName-feedback"
                        >
                    </b-form-input>
                    <b-form-invalid-feedback id="englishName-feedback">
                        This is a required field and must be at least 3 characters.
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                label="Arabic Name"
                label-for="arabicName" >
                    <b-form-input
                        type="text"
                        id="txtArabicName"
                        name="txtArabicName"
                        placeholder="Arabic Name"
                        v-model="$v.form.arabicName.$model"
                        :state="validateState('arabicName')"
                        aria-describedby="arabicName-feedbackk"
                        >
                    </b-form-input>
                    <b-form-invalid-feedback id="arabicName-feedback">
                        This is a required field and must be at least 3 characters.
                    </b-form-invalid-feedback>
                </b-form-group>
            <b-button type="submit" variant="primary">Update</b-button>
            <b-button class="ml-2" @click="onReset()">Reset</b-button>
            </b-form>
         </b-modal> -->
          <v-container color="primary">
              <v-card
                    icon="clipboard-text"
                    title="Economic Sector"
                    class="px-5 py-10">
                    <v-card-title>
                        <v-row>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details>
                            </v-text-field>
                        </v-row>
                        <v-row>
                            <v-progress-linear
                                :active="loading"
                                color="green"
                                :indeterminate="loading"
                                absolute
                                bottom
                                height="15">
                                Loading...
                            </v-progress-linear>`
                        </v-row>
                    </v-card-title>
                    <v-data-table
                        dense
                        :headers="fields"
                        :items="items"
                        :search="search"
                        class="elevation-1">
                        <template  v-slot:[`header.id`]="{ header }">
                                <h6><b> {{ header.text}}</b> </h6>
                        </template>
                        <template  v-slot:[`header.englishName`]="{ header }">
                                <h6><b> {{ header.text}}</b> </h6>
                            </template>
                            <template  v-slot:[`header.arabicName`]="{ header }">
                                <h6><b> {{ header.text}}</b> </h6>
                            </template>
                             <template  v-slot:[`header.Action`]="{ header }">
                                <h6><b> {{ header.text}}</b> </h6>
                            </template>
                              <template v-slot:top>
                                  <v-dialog
                                    v-model="Editdialog"
                                    max-width="800px">
                                        <v-card>
                                             <v-card-title>
                                                <span class="text-h5">Edit Legal Structure</span>
                                            </v-card-title>
                                            <v-card-text>
                                                 <v-form ref="form" v-model="valid" lazy-validation>
                                                    <v-container>
                                                         <v-row>
                                                            <v-col cols="12" sm="6" md="6">
                                                                 <v-text-field
                                                                    v-model="editedItem.englishName"
                                                                    :rules="[rules.required]"
                                                                    required
                                                                    label="English Name">
                                                                </v-text-field>
                                                            </v-col>
                                                         </v-row>
                                                         <v-row>
                                                            <v-col cols="12" sm="6" md="6">
                                                                 <v-text-field
                                                                    v-model="editedItem.arabicName"
                                                                    :rules="[rules.required]"
                                                                    required
                                                                    label="Arabic Name">
                                                                </v-text-field>
                                                            </v-col>
                                                         </v-row>
                                                    </v-container>
                                                 </v-form>
                                            </v-card-text>
                                             <v-card-actions>
                                                <v-spacer></v-spacer>
                                                 <v-btn color="blue darken-1" text @click="close"> Cancel</v-btn>
                                                 <v-btn color="blue darken-1" :disabled="!valid" text @click="validate" >Save</v-btn>
                                             </v-card-actions>
                                        </v-card>
                                  </v-dialog>
                              </template>
                               <template v-slot:[`item.Action`]="{ item }">
                                    <v-icon small class="mr-2"  @click="editItem(item)" >
                                        mdi-pencil
                                    </v-icon>
                                     <v-icon small class="mr-2"  @click="approveRequestConfirm(item)" color="red" v-if="item.status==0" >
                                        mdi-brightness-1
                                    </v-icon>
                                     <v-icon small class="mr-2"  @click="approveRequestConfirm(item)" color="green" v-if="item.status==1" >
                                        mdi-brightness-1
                                    </v-icon>
                                    <v-icon small class="mr-2"  @click="approveDeleteConfirm(item)" color="red"  >
                                        mdi-delete-empty
                                    </v-icon>
                                </template>
                    </v-data-table>
                </v-card>
          </v-container>
           <v-dialog v-model="approveReqDialog" max-width="500px">
                <v-card
                :loading = loading loading-text="Loading... Please wait">
                    <v-card-title class="text-h3">Are you sure ? </v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="updateSectorStatus">Yes</v-btn>
                    <v-btn color="green darken-1" text @click="closeApprove">No</v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
                </v-dialog>

                 <v-dialog v-model="confirmDeleteDialog" max-width="500px">
                    <v-card
                    :loading = loading loading-text="Loading... Please wait">
                        <v-card-title class="text-h3">Are you sure ? </v-card-title>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="deleteSector">Yes</v-btn>
                        <v-btn color="green darken-1" text @click="confirmDeleteDialog = false">No</v-btn>
                        <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog
        v-model="addLeagalStructuerDialog"
        max-width="800px">
            <v-card>
                    <v-card-title>
                    <span class="text-h5">Add Legal Structure</span>
                </v-card-title>
                <v-card-text>
                        <v-form ref="Addform" v-model="valid" lazy-validation>
                        <v-container>
                                <v-row>
                                <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                        v-model="editedItem.englishName"
                                        :rules="[rules.required]"
                                        required
                                        label="English Name">
                                    </v-text-field>
                                </v-col>
                                </v-row>
                                <v-row>
                                <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                        v-model="editedItem.arabicName"
                                        :rules="[rules.required]"
                                        required
                                        label="Arabic Name">
                                    </v-text-field>
                                </v-col>
                                </v-row>
                        </v-container>
                        </v-form>
                </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close"> Cancel</v-btn>
                        <v-btn color="blue darken-1" :disabled="!valid" text @click="validateNew" >Save</v-btn>
                    </v-card-actions>
            </v-card>
        </v-dialog>
        <div class="text-center">
                <v-snackbar v-model="snackbar" timeout="3000">
                    {{ alertMsg }}
                    <template v-slot:action="{ attrs }">
                        <v-btn
                            color="green"
                            text
                            v-bind="attrs"
                            @click="snackbar = false">
                            Close
                        </v-btn>
                    </template>
            </v-snackbar>
        </div>

  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
export default {
    mixins: [validationMixin],
    data(){
        return{
            search:'',
            valid:false,
            alertMsg:'',
            loading:false,
            addLeagalStructuerDialog:false,
            confirmDeleteDialog:false,
            snackbar:false,
            approveReqDialog:false,
            Editdialog:false,
            fields: [
                {value: 'id', text: this.$t("legalStructure.grid.id") },
                {value: 'englishName', text: this.$t("legalStructure.grid.englishName") },
                {value: 'arabicName', text: this.$t("legalStructure.grid.arabicName") },
                {value: 'Action', text: this.$t("legalStructure.grid.Action") }
                ],
            items: [],
            editedItem: {
                id:-1,
                arabicName: '',
                englishName:'',
                status:-1,
            },
            editedIndex:null,
             rules: {
                required: value => !!value || 'Required Field',
            },
           form: {
                englishName: null,
                arabicName:null,
                id:null
            },
            currentEditedSector:null
        }
    },
     validations: {
        form: {
            englishName: {
                required,
                minLength: minLength(3)
            },
            arabicName: {
                required,
                minLength: minLength(3)
            }
        }
    },
    methods:{
         approveDeleteConfirm(item){
            this.editedItem = item;
            this.editedIndex = this.items.indexOf(item)
            this.confirmDeleteDialog = true
        },
         close () {
            this.Editdialog = false
            this.addLeagalStructuerDialog = false;
            this.$nextTick(() => {
                this.clear();
            })
        },
        closeApprove(){
            this.approveReqDialog = false;
            this.clear();
        },
        clear(){
            this.editedIndex = -1
            this.editedItem.id = -1;
            this.editedItem.arabicName = '';
            this.editedItem.englishName = '';
        },
        validate () {
            if(this.$refs.form.validate())
            {
                this.updateLegalStructure();
            }
         },
         validateNew () {
            if(this.$refs.Addform.validate())
            {
                this.AddLegalStructure();
            }
         },
         editItem (item) {
            this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.Editdialog = true
        },
         approveRequestConfirm(item){
            this.editedItem = item;
            this.editedIndex = this.items.indexOf(item)
            this.approveReqDialog = true;
        },
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        editLegalStructure(item,index)
        {
            this.form.englishName = item.englishName;
            this.form.arabicName = item.arabicName;
            this.form.id = item.id;
            this.$bvModal.show('EditLegalStructure');
            this.currentEditedSector = index;

        },
         updateSectorStatus(){
             this.$axios({
                    method: 'put',
                    url: `${this.$baseURL}/LegalStructure/status`,
                    params:{
                        Id:this.editedItem.id,
                        status:this.editedItem.status == 1 ? 0:1
                    }
                }).then(()=>{
                    this.approveReqDialog = false;


                                this.editedItem.status == 1 ?
                                this.editedItem.status = 0: this.editedItem.status = 1
                                    Object.assign(this.items[this.editedIndex], this.editedItem)
                                this.alertMsg = "Legal structure updated successfully"
                                this.snackbar = true;


                });

        },
         getVariant(item,activateSector){
            if(Boolean(activateSector) == true){
                if(item.status == 1)
                    return 'primary'
                else
                    return 'secondary'
            }
            else{
                if(item.status == 1)
                    return 'secondary'
                else
                    return 'primary'
            }

        },
        deleteSector(){
            this.$axios({
                    method: 'delete',
                    url: `${this.$baseURL}/LegalStructure`,
                    data: {Id:this.editedItem.id}
                    }).then(()=>{
                         this.items .splice(this.editedIndex , 1);
                        this.confirmDeleteDialog = false;
                    });
        },
        updateLegalStructure(){
             this.$axios({
                    method: 'put',
                    url: `${this.$baseURL}/LegalStructure`,
                    data: {
                        EnglishName: this.editedItem.englishName,
                        ArabicName: this.editedItem.arabicName,
                        id:this.editedItem.id
                    }
                }).then((response)=>{
                    if(response.data == true)
                    {
                         Object.assign(this.items[this.editedIndex], this.editedItem)
                        this.close()
                        this.alertMsg = "Legal Structure updated successfully"
                        this.snackbar = true;
                    }
                });
        },
        AddLegalStructure(){

            this.$axios({
                    method: 'post',
                    url: `${this.$baseURL}/LegalStructure`,
                    data: {
                        EnglishName: this.editedItem.englishName,
                        ArabicName: this.editedItem.arabicName
                    }
                }).then((response)=>{

                   if(JSON.parse(response.data.status) == true)
                    {
                            this.$nextTick(() => {
                                this.items = response.data.result;
                                this.close()
                                this.alertMsg = "Legal Structure added successfully"
                                this.snackbar = true;
                            });
                    }

                });




        },
        onReset(){
             this.form ={
                englishName: null,
                arabicName:null
            };
             this.$nextTick(() => {
                this.$v.$reset();
            });
        },

    },
    mounted(){
        this.loading  = true;
        this.$axios({
                    method: 'get',
                    url: `${this.$baseURL}/LegalStructure`,
                })
                .then((response)=>{
                     this.items = response.data.result;
                    this.loading = false;
                });
    }
}
</script>

<style>

</style>